import NotFoundLoader from './Error404Loader';
export default NotFoundLoader;
